// src/vocabulary/A2/unit2/content.js

const content = {
  level: "A2",
  unit: 2,
  title: "Food",
  description:
    "Common types of food and meals. Learn how to talk about what you eat and what you like.",

  explanation: [
    "This unit focuses on common food items and meals.",
    "You can use these words to talk about what you eat every day.",
    "In English, we often talk about food using simple sentences in the present tense.",
    "For example: I eat rice for lunch. I like fruit.",
    "You can use 'like' and 'don't like' to talk about your preferences.",
    "Meals are usually breakfast, lunch, and dinner.",
    "Food vocabulary is very useful in daily conversations and while traveling.",
    "Try to talk about your favorite food and what you eat during the day."
  ],

  items: [
    {
      word: "bread",
      phonetic: "/bred/",
      meaning: "خبز",
      example: "I eat bread for breakfast."
    },
    {
      word: "rice",
      phonetic: "/raɪs/",
      meaning: "أرز",
      example: "Rice is a common food."
    },
    {
      word: "chicken",
      phonetic: "/ˈtʃɪkɪn/",
      meaning: "دجاج",
      example: "She cooks chicken for dinner."
    },
    {
      word: "vegetables",
      phonetic: "/ˈvedʒtəblz/",
      meaning: "خضروات",
      example: "Vegetables are healthy."
    },
    {
      word: "fruit",
      phonetic: "/fruːt/",
      meaning: "فاكهة",
      example: "I eat fruit every day."
    },
    {
      word: "breakfast",
      phonetic: "/ˈbrekfəst/",
      meaning: "فطور",
      example: "Breakfast is my favorite meal."
    },
    {
      word: "dinner",
      phonetic: "/ˈdɪnər/",
      meaning: "عشاء",
      example: "We have dinner at seven."
    }
  ]
};

export default content;


